import React, { useState } from 'react';
import Navbar from '../pages/Navbar';
import MainSlide from './MainSlide';
import Download from './Download';
import Fotter from '../../../Footer/Footer';
import { useEffect } from 'react';
import ChatbotWidget from '../ChatbotWidget';

const Home = ({ history }) => {
  // useEffect(() => {
  //   window.history.pushState(null, document.title, window.location.href);

  //   window.addEventListener('popstate', function (event) {
  //     window.history.pushState(null, document.title, window.location.href);
  //   });
  // }, [history]);
  // const storedUserId = localStorage.getItem('userId');

  // useEffect(() => {
  //   console.log("storage : " + storedUserId);
  // }, [])

  return (
    <div>
      <Navbar style={{ zIndex: 1 }} />
      <MainSlide style={{ zIndex: 2 }} />
      {/* <div style={{ margin: '5vh 0', zIndex: 3 }}></div> */}

      {/* Steps section removed for Travel Immigration */}
      {/* Features section removed for Travel Immigration */}

      <Fotter style={{ zIndex: 10 }} />
      <ChatbotWidget />
    </div>
  );
};

export default Home;
